<script>
import ModelList from "./model-list.vue";

export default {
  name: "history-modal",
  components: {ModelList},
  data() {
    return {
      user: 'self',
      models: []
    }
  },
  computed: {
    users() {
      return this.$store.state.settings.defaults.users.map(u => {
        return {text: u.name, value: u.id === this.$store.state.auth.id ? 'self' : u.id}
      })
    },
  },
  mounted() {
    this.refresh()
  },
  watch: {
    user() {
      this.refresh()
    }
  },
  methods: {
    refresh() {
      this.asyncAction('/api/user/' + this.user + '/history', 'get').then(v => this.models = v)
    },
    clicked(m) {
      this.$refs.modal.close()
      this.modalRoute(m)
    }
  }
}
</script>

<template>
  <modal title="History" height="400px" ref="modal">
    <template #top v-if="can('users.history')">
      <b-select v-model="user"
                :options="users"/>
    </template>
    <model-list :models="models" @click="clicked"/>
  </modal>
</template>

<style scoped>

</style>